import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-orientation-overlay',
    templateUrl: './orientation-overlay.component.html',
    styleUrls: ['./orientation-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIcon]
})
export class OrientationOverlayComponent implements OnInit {
  public isLandscape: boolean = true;

  ngOnInit(): void {
    this.checkOrientation();
  }

  @HostListener('window:resize')
  public onResize(): void {
    this.checkOrientation();
  }

  private checkOrientation(): void {
    this.isLandscape = window.matchMedia('(orientation: landscape)').matches;
  }
}